if (!customElements.get('gpg-home-ranking')) {
 customElements.define('gpg-home-ranking',class extends HTMLElement {
  connectedCallback() {
   if (this.loaded) return;
   this.loaded=true;
   this.controller=new AbortController();
   const url=new URL(this.dataset.url,location.origin);
   if(url.origin!==location.origin) return;
   fetch(url,{signal:this.controller.signal}).then(r=>{if(!r.ok)throw new Error('Ranking unavailable');return r.text();}).then(html=>{
    const list=new DOMParser().parseFromString(html,'text/html').querySelector('.gpg-home-rank');
    if(list&&list.children.length&&this.isConnected) this.replaceChildren(list);
   }).catch(()=>{});
  }
  disconnectedCallback(){this.controller?.abort();this.loaded=false;}
 });
}
